import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { SectionService } from "../../../services/sections/serction.service";
import { SectionModel } from "../../../services/sections/models/section.model";
import { Badge, Col, Row } from "antd";
import { TableService } from "../../../services/tables/table.service";
import { TableModel } from "../../../services/tables/models/tabele.model";
import InfiniteScroll from "react-infinite-scroll-component";
import WaiterTableDetailOrderModal from "../components/tables/WaiterTableOrderModal";
import { OrderStateModel } from "../../../services/orders/models/order_state.model";
import { OrderService } from "../../../services/orders/order.service";
import * as signalR from "@microsoft/signalr";
import { WaiterHubs } from "../../../consts/SignaIR.const";
import { WaiterHubEnum } from "../../../enums/waiter_hub.enum";
import { WaiterModel } from "../../../models/waiter.model";
import { WaiterService } from "../../../services/waiters/waiter.service";
import { useDispatch, useSelector } from "react-redux";
import {
  getCompanyId,
  getUserId,
} from "../../../react-reduxs/slices/auth/auth_slice";
import { OrderProductStatusModel } from "../../../services/order_product_statuses/models/order_product_status.model";
import { OrderProductStatusService } from "../../../services/order_product_statuses/order_product_status.service";
import { OrderProductStatusEnum } from "../../../enums/orders/order_status.enum";
import { OrderHubUrl } from "../../../consts/api";
import { toast } from "react-toastify";
import MenuProductServcie from "../../../services/menu_products/menu_product.service";
import MenuCategoryService from "../../../services/menu_categories/menu_category.service";
import { AppDispatch } from "../../../react-reduxs/configure_store";
import { setProductList } from "../../../react-reduxs/slices/products/product_slice";
import { setCategoryList } from "../../../react-reduxs/slices/categories/category_slice";
import { PrinterService } from "../../../services/printers/printer.service";
import { setPrinterList } from "../../../react-reduxs/slices/printers/printer_slice";
import ThemeCard from "@theme/ui-components/cards/ThemeCard";
import { Divider } from "primereact/divider";
import { requestNotificationPermission } from "../../../firebase/firebase-init";
import NotificationSettingServcie from "../../../services/notification_settings/notification_setting.service";
import { NotificationSettingModel } from "../../../services/notification_settings/models/notification-setting.model";

const WaiterHomePage: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const userId = useSelector(getUserId);
  const companyId = useSelector(getCompanyId);

  // Ses Dosyası Referansı (public/sounds/notification.mp3 yolunda olmalı)
  const audioRef = useRef<HTMLAudioElement>(new Audio("/music/waiterCall.mp3"));

  const tableListRef = useRef<TableModel[]>([]);
  const sectionListRef = useRef<SectionModel[]>([]);
  const orderStateModelListRef = useRef<OrderStateModel[]>([]);

  const sectionService = useMemo(() => new SectionService(), []);
  const tableService = useMemo(() => new TableService(), []);
  const orderService = useMemo(() => new OrderService(), []);
  const printerService = useMemo(() => new PrinterService(), []);
  const waiterService = useMemo(() => new WaiterService(), []);
  const orderProductStatusService = useMemo(
    () => new OrderProductStatusService(),
    [],
  );
  const menuProductService = useMemo(() => new MenuProductServcie(), []);
  const notificationSettingService = useMemo(
    () => new NotificationSettingServcie(),
    [],
  );
  const menuCategoryService = useMemo(() => new MenuCategoryService(), []);

  const [orderProductStatusList, setOrderProductStatusList] = useState<
    OrderProductStatusModel[]
  >([]);
  const [count, setCount] = useState<number>(0);
  const [setsectionList, setSetsectionList] = useState<SectionModel[]>([]);
  const [tableList, setTableList] = useState<TableModel[]>([]);
  const [selectedSection, setSelectedSection] = useState<string>("");
  const [orderStateModelList, setOrderStateModelList] = useState<
    OrderStateModel[]
  >([]);
  const [hupStartedList, setHupStartedList] = useState<any[]>([]);
  const [waiterCallList, setWaiterCallList] = useState<WaiterModel[]>([]);

  // Ses Çalma Fonksiyonu
  const playNotification = useCallback(() => {
    if (audioRef.current) {
      audioRef.current.currentTime = 0; // Sesi başa sar
      audioRef.current
        .play()
        .catch((err) => console.error("Audio Play Error:", err));
    }
  }, []);

  const getOrder = useCallback(async () => {
    let orderResponse = await orderService.getOrderList(companyId);
    if (orderResponse) {
      setOrderStateModelList(orderResponse);
      orderStateModelListRef.current = orderResponse;
    }
  }, [companyId, orderService]);

  const getWaiterCall = useCallback(async () => {
    let response = await waiterService.getWaiterCallListByCompanyId(companyId);
    if (response) {
      setWaiterCallList(response);
    }
  }, [companyId, waiterService]);

  const getOrderProductStatusList = useCallback(async () => {
    let response = await orderProductStatusService.getList();
    if (response) {
      setOrderProductStatusList(response);
    }
  }, [orderProductStatusService]);

  const getSignaIRHub = useCallback(async () => {
    WaiterHubs.forEach(async (hup) => {
      let connection = new signalR.HubConnectionBuilder()
        .withAutomaticReconnect()
        .withUrl(hup.val(companyId).url)
        .build();

      const startConnection = async () => {
        try {
          await connection.start();
          await getOrder();
          await getWaiterCall();
          console.log(`${hup.name} SignalR bağlantısı kuruldu.`);
        } catch (error) {
          console.error("SignalR bağlantısı hatası:", error);
          setTimeout(startConnection, 5000);
        }
      };

      connection.onclose(() => startConnection());
      await startConnection();

      // SİPARİŞ HUB DİNLEME
      if (hup.name === WaiterHubEnum.order) {
        connection.on("WaiterOrderList", (order, type) => {
          setOrderStateModelList(order);
          orderStateModelListRef.current = order;
          if (type === "call") {
            playNotification(); // SESİ ÇAL
            toast.info("Yeni sipariş geldi!");
          }
        });
      }

      // GARSON ÇAĞRI HUB DİNLEME
      if (hup.name === WaiterHubEnum.waiterCall) {
        connection.on(hup.val(companyId).event, (waiter, type) => {
          if (type === "call") {
            playNotification(); // SESİ ÇAL
            const lastCall = waiter[waiter.length - 1];
            const table = tableListRef.current.find(
              (x) => x.id === lastCall?.tableId,
            );
            const section = sectionListRef.current.find(
              (x) => x.id === table?.sectionId,
            );

            if (Notification.permission === "granted") {
              new Notification("Garson Çağrı!", {
                body: `Bölüm: ${section?.name || ""} - Masa: ${table?.name || ""}`,
                icon: "/logo192.png",
              });
            }
          }
          setWaiterCallList(waiter);
        });
      }
      setHupStartedList((prev) => [...prev, connection]);
    });
  }, [companyId, getOrder, getWaiterCall, playNotification]);

  const getTableList = useCallback(
    async (sectionId: string) => {
      let tableResponse = await tableService.getListByCompanyId(companyId);
      if (tableResponse.length > 0) {
        tableListRef.current = tableResponse;
        setTableList(tableResponse.filter((c) => c.sectionId === sectionId));
      }
    },
    [companyId, tableService],
  );

  const getProductList = useCallback(async () => {
    const response = await menuProductService.getListByStatus(companyId, true);
    if (response) dispatch(setProductList(response));
  }, [menuProductService, companyId, dispatch]);

  const getPrinterList = useCallback(async () => {
    const response = await printerService.getList(companyId);
    if (response) dispatch(setPrinterList(response));
  }, [printerService, companyId, dispatch]);

  const getCategoryList = useCallback(async () => {
    const response = await menuCategoryService.getListByStatus(companyId, true);
    if (response) dispatch(setCategoryList(response));
  }, [menuCategoryService, dispatch, companyId]);

  const initialLoad = useCallback(async () => {
    if (!companyId) return;
    try {
      let sectionResponse = await sectionService.getListByCompanyId(companyId);
      if (sectionResponse.length > 0) {
        setSetsectionList(sectionResponse);
        sectionListRef.current = sectionResponse;
        setSelectedSection(sectionResponse[0].id);
        await getTableList(sectionResponse[0].id);
        await getOrderProductStatusList();
        await getSignaIRHub();
        await getProductList();
        await getCategoryList();
        await getPrinterList();
      }
    } catch (error) {
      console.error("Initial Load Error:", error);
    }
  }, [
    companyId,
    getOrderProductStatusList,
    getSignaIRHub,
    getTableList,
    getProductList,
    getCategoryList,
    getPrinterList,
    sectionService,
  ]);

  useEffect(() => {
    if (count === 0) {
      initialLoad();
      onTokenCallback();
      setCount(1);
    }

    // Tarayıcı Ses İzni İçin İlk Tıklamayı Dinle
    const unlockAudio = () => {
      audioRef.current.play().then(() => {
        audioRef.current.pause();
        window.removeEventListener("click", unlockAudio);
      });
    };
    window.addEventListener("click", unlockAudio);

    return () => {
      window.removeEventListener("click", unlockAudio);
      hupStartedList.forEach((hub) => hub.stop());
    };
  }, [count, hupStartedList, initialLoad]);

  const selectSection = (sectionId: string) => {
    setTableList(tableListRef.current.filter((x) => x.sectionId === sectionId));
    setSelectedSection(sectionId);
  };

  const updateOrderProductStatus = useCallback(
    async (
      tableIdP: string,
      orderProductId: number,
      orderProductStatusId: number,
    ) => {
      const connection = new signalR.HubConnectionBuilder()
        .withUrl(OrderHubUrl(companyId).url)
        .withAutomaticReconnect()
        .build();

      try {
        await connection.start();
        await connection.invoke(
          "OrderProductStatusUpdate",
          parseInt(companyId.toString()),
          tableIdP,
          orderProductId,
          orderProductStatusId,
        );
      } catch (error) {
        console.error(error);
      } finally {
        connection.stop();
      }
    },
    [companyId],
  );

  const getOrderCount = (sectionId: string) => {
    let sum = 0;
    let tableL = tableListRef.current.filter((x) => x.sectionId === sectionId);
    tableL.forEach((element) => {
      let order = orderStateModelList.find(
        (x) => x.order.tableId === element.id,
      );
      let waiter = waiterCallList.filter((x) => x.tableId === element.id);
      if (waiter) sum += waiter.length;
      if (order) {
        sum += order.orderProductList.filter(
          (x) => x.status.text === OrderProductStatusEnum.pendingApproval,
        ).length;
      }
    });
    return sum;
  };

  const onTokenCallback = useCallback(async () => {
    try {
      const token = await requestNotificationPermission();
      if (token && userId != "") {
        notificationSettingService.add({
          userId,
          token,
          isActive: true,
        } as NotificationSettingModel);
      }
    } catch (error) {
      console.error("FCM Token Error:", error);
    }
  }, [userId, notificationSettingService]);

  return (
    <div>
      <Row
        style={{
          overflow: "auto",
          whiteSpace: "nowrap",
          flexFlow: "nowrap",
          paddingTop: 10,
        }}
      >
        {setsectionList.map((x) => (
          <Badge key={x.id} count={getOrderCount(x.id)}>
            <Col style={{ marginLeft: 20, paddingBottom: 5 }}>
              <ThemeCard
                title={x.name}
                severity="high"
                selected={selectedSection === x.id}
                onClick={() => selectSection(x.id)}
              >
                <img
                  width={65}
                  height={65}
                  alt="section-logo"
                  src={
                    x.logo ? x.logo.toApiImage() : "restaurant.png".toApiImage()
                  }
                />
              </ThemeCard>
            </Col>
          </Badge>
        ))}
      </Row>
      <Divider align="left">
        <span className="p-tag">Masalar</span>
      </Divider>
      <div style={{ overflow: "auto", maxHeight: "calc(100vh - 255px)" }}>
        <InfiniteScroll
          next={() => {}}
          dataLength={tableList.length}
          hasMore={false}
          loader={null}
        >
          <Row style={{ marginTop: 10 }}>
            {tableList.map((x) => (
              <Col
                flex={1}
                key={x.id}
                style={{ marginRight: 10, marginBottom: 20, width: 150 }}
              >
                <WaiterTableDetailOrderModal
                  updateOrderProductStatus={updateOrderProductStatus}
                  orderProductStatusList={orderProductStatusList}
                  waiterModel={waiterCallList.find((y) => y.tableId === x.id)}
                  item={x}
                  order={orderStateModelList.find(
                    (or) => or.order.tableId === x.id,
                  )}
                />
              </Col>
            ))}
          </Row>
        </InfiniteScroll>
      </div>
    </div>
  );
};

export default WaiterHomePage;
